export const GENERATION_ID_MAP = {
    '2': 'cascade-lake',
    '3': 'ice-lake',
};

export const GENERATION_ORDER = ['2', '3'];

export const PRESET_TYPE_ORDER = ['io-optimized', 'memory-optimized', 'standard'];

export const DISK_TYPE_ID_ORDER = [
    'network-ssd',
    'network-hdd',
    'network-ssd-nonreplicated',
    'local-ssd',
];
